var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.news = {
	init:function () {
		if(!$('.entryImageText').length){
			$('.entryImage').css('padding-bottom', '28px');
		}

	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.checkAside = {
	init: function () {
		var $aside = $('aside');
		if($aside.length > 0 && $aside.height() > 0) {
			var $main = $('#main');
			$(window).on('resize', function(){
				var win = $(this);
				if (win.height() > 991) {
					$main.css('min-height', 0);
				}
				else {
					var extraheight = $aside.find('#banner').length > 0 ? $aside.height() - 510 : $aside.height();
					$main.css('min-height', extraheight);
				}
			});
			if($(window).width() > 991) {
				var extraheight = $aside.find('#banner').length > 0 ? $aside.height() - 510 : $aside.height();
				$main.css('min-height', extraheight);
			}
		}
	}
};

site.frontpage = {
	init: function() {
		$('.image', '#custom-banner').bgLoaded();

		site.owl.init('main .box_newsheadlines .news__entries', {
			nav: true,
			loop: false,
			dots: false,
			navText: ["<i class=\"fas fa-chevron-left\"></i>", "<i class=\"fas fa-chevron-right\"></i>"],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 1.831,
					margin: 77
				},
				992: {
					items: 2,
					margin: 30
				},
				1200: {
					items: 3,
					margin: 30
				}
			},
			onInitialized: function() {
				$('.owl-nav .owl-prev').attr('aria-label', "Fyrri frétt");
				$('.owl-nav .owl-next').attr('aria-label', "Næsta frétt");
			}
		});
		site.sideContent.init();

		site.owl.init('main .box_extras_items .items', {
			nav: true,
			loop: false,
			dots: false,
			navText: ["<i class=\"fas fa-chevron-left\"></i>", "<i class=\"fas fa-chevron-right\"></i>"],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			margin: 30,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 4
				}
			},
			onInitialized: function() {
				$('.owl-nav .owl-prev').attr('aria-label', "Fyrra atriði");
				$('.owl-nav .owl-next').attr('aria-label', "Næsta atriði");
			}
		});

		site.owl.init('main .box_calendar_eventlist .boxes', {
			nav: true,
			loop: false,
			dots: false,
			navText: ["<i class=\"fas fa-chevron-left\"></i>", "<i class=\"fas fa-chevron-right\"></i>"],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			margin: 15,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 3
				},
				1600: {
					items:4
				}
			},
			onInitialized: function() {
				$('.owl-nav .owl-prev').attr('aria-label', "Fyrri viðburður");
				$('.owl-nav .owl-next').attr('aria-label', "Næsti viðburður");
			}
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	//site.mobileSearch.appendSearch();
	site.megamenu.init();
	site.labelFocus.init();
	site.headSearch.init();
	site.checkAside.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if($body.is('.newsView')) {
		site.news.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
